<template>
    <div class="popup" v-if="isOpen">
        <div class="popup_main">
            <form @submit.prevent="sendForm">
                <img src="@/assets/logo-big-bro-black-white.png">
                <h5>Оставьте Ваши контакты и мы свяжемся с Вами в ближайшее время</h5>
                <input v-model="form.name" type="text" name="name" id="name" placeholder="Имя">
                <MaskInput v-model="form.phone" mask="# (###) ### ## ##" type="text" name="phone" id="phone" placeholder="Телефон" />
                <input v-model="form.city" type="text" name="city" id="city" placeholder="Город">
                <div v-show="message !== ''" style="align-self: center; line-height: 100%; font-size: 24px; color: #DFB700;">{{ message }}</div>
                <Button :disabled="!form.name || !form.phone || !form.city" type="submit" @click="trackGoal"><slot>Отправить</slot></Button>
            </form>
            <p @click="this.$emit('closePop')">&#10006;</p>
        </div>
    </div>
</template>

<script>
    import { MaskInput } from 'vue-3-mask';
    import Button from './Button.vue';
    export default {
        props: {
            isOpen: {
                type: Boolean,
                required: true
            }
        },
        components: {
            Button,
            MaskInput
        },
        data() {
            return {
                form: {
                    name: '',
                    phone: '',
                    city: ''
                }
            }
        },
        methods: {
            sendForm() {
                this.$emit('sendPopForm', this.form)
                this.props.isOpen = false
            },
            trackGoal() {
                if (window.ym) {
                    // Идентификатор счетчика (замените на ваш)
                    window.ym(98455671, 'reachGoal', 'form_sent');
                    console.log('Цель отправлена в Яндекс Метрику');
                } else {
                    console.warn('Яндекс Метрика не подключена');
                }
            }
        }
    }
</script>

<style scoped>
    .popup {
        width: 100%;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, .7);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1001;
    }
    .popup_main {
        width: 600px;
        display: block;
        position: relative;
    }
    .popup_main p {
        position: absolute;
        top: 24px;
        right: 24px;
        transform: translate(50%, -50%);
        color: #DFB700;
        cursor: pointer;
        font-size: 24px;
    }
    .popup_main form {
        display: flex;
        width: 100%;
        flex-direction: column;
        gap: 32px;
        box-sizing: border-box;
        padding: 32px;
        background-color: #fff;
    }
    .popup_main form h5 {
        font-size: 24px;
        font-weight: 700;
        text-align: center;
        color: #DFB700;
        line-height: 100%;
    }
    .popup_main form input {
        box-sizing: border-box;
        width: 100%;
        padding: 12px 12px;
        border-radius: 32px;
        border: 1px solid #333;
        box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 25);
    }
    @media all and (max-width: 440px) {
        .popup_main {
        width: 100%;
        display: block;
        position: relative;
    }
    .popup_main p {
        position: absolute;
        top: 24px;
        right: 24px;
        transform: translate(50%, -50%);
        color: #DFB700;
        cursor: pointer;
        font-size: 24px;
    }
    .popup_main form {
        display: flex;
        width: 100%;
        flex-direction: column;
        gap: 32px;
        box-sizing: border-box;
        padding: 32px;
        background-color: #fff;
    }
    .popup_main form h5 {
        font-size: 24px;
        font-weight: 700;
        text-align: center;
        color: #DFB700;
        line-height: 100%;
    }
    .popup_main form input {
        box-sizing: border-box;
        width: 100%;
        padding: 12px 12px;
        border-radius: 32px;
        border: 1px solid #333;
        box-shadow: 0px 2px 0px 0px rgba(0, 0, 0, 25);
    }
    }
</style>